
import styles from "./Style.module.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SaleInfoLoader = () => {
  return (
    <div className={styles.SaleInfoLoader}>
      {/* Top Section (Check-in & Checkout button) */}
      <div className={styles.topSection}>
        <Skeleton width={150} height={18} />
        <div className={styles.topSectionRight}>
          <Skeleton width={32} height={32} borderRadius="50%" />
          <Skeleton width={32} height={32} borderRadius="50%" />
        </div>
      </div>
      <div className={styles.line}/>

      {/* Client Info */}
      <div className={styles.clientInfo}>
        <div className={styles.avatar}>
          <Skeleton circle width={60} height={60} />
        </div>
        <div className={styles.clientText}>
          <Skeleton width={180} height={20} />
          <Skeleton width={120} height={10} />
        </div>
      </div>

      <div className={styles.line}/>

      {/* Service Info */}
      <div className={styles.serviceInfo}>
        <div className={styles.serviceTitle}>
        <Skeleton width={200} height={20} /> {/* Service Name */}
        <Skeleton width={32} height={20} /> {/* With price */}
        </div>
        <div className={styles.gap}/>
        <Skeleton width={140} height={15} /> {/* With therapist */}
      </div>

      <div className={styles.line}/>


      {/* Service Info */}
      <div className={styles.priceInfo}>
        <div className={styles.rw}>
          <div className={styles.col}>
            <Skeleton width={140} height={20} />
          </div>
          <div className={styles.col}>
            <Skeleton width={100} height={20} />
          </div>
        </div>
        <div className={styles.rw}>
          <div className={styles.col}>
            <Skeleton width={140} height={20} />
          </div>
          <div className={styles.col}>
            <Skeleton width={100} height={20} />
          </div>
        </div>
        <div className={styles.rw}>
          <div className={styles.col}>
            <Skeleton width={140} height={20} />
          </div>
          <div className={styles.col}>
            <Skeleton width={100} height={20} />
          </div>
        </div>
      </div>

      <div className={styles.line}/>
      
      <div className={styles.paymentInfo}>
        <div className={styles.rw}>
          <div className={styles.col}>
            <Skeleton width={140} height={20} />
          </div>
          <div className={styles.col}>
            <Skeleton width={100} height={20} />
          </div>
        </div>
      </div>


      {/* Booking Details */}
      <div className={styles.bookingDetails}>
        <Skeleton width={140} height={20} />
        <div className={styles.gap}/>
        <Skeleton width={200} height={15} />
        <Skeleton width={200} height={15} />
        <Skeleton width={200} height={15} />
        <Skeleton width={200} height={15} />
      </div>
    </div>
  );
};

export default SaleInfoLoader;
